
import { Toaster } from "react-hot-toast";
import Contact from "./component/Contact";
import Header ,{HeaderPhone} from "./component/Header";
import Home from "./component/Home";
import Services from "./component/Services";
import Testimonial from "./component/Testimonial";
import Timeline from "./component/Timeline";
import Work from "./component/Work";
import Footer from "./component/Footer";
import {useEffect, useState} from "react";

function App() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [ratio, setRatio] = useState(window.innerWidth / window.innerHeight);
  useEffect(() => {
    const resizeRatio = () => {
      setRatio(window.innerWidth / window.innerHeight);
    };

    window.addEventListener("resize", resizeRatio);

    return () => {
      window.removeEventListener("resize", resizeRatio);
    };
  }, [ratio]);

  return <>
     <HeaderPhone menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Home ratio={ratio} />
      <Work />
      <Timeline />
      <Services />
      <Testimonial />
      <Contact />
      <Footer />
      <Toaster />
    

  
  </>
}

export default App;
